angular.module('swapick')
.controller('HelpCtrl',  HelpCtrl);

function HelpCtrl () {
  console.log('Help Controller');
}



// WEBPACK FOOTER //
// ./src/controllers/help-controller.js